/* Nordic Forest Rituals – inspiration card demo
   - The draw button flips a random card from the cards in the markup.
   - The "draw again" button turns the card back over and draws another one.
   - Language neutral: all visible texts and screen-reader labels come from the markup
     (data-label-draw / data-label-drawn on .nfr-kd), so the same file serves every language.
   - Cards are drawn like from a real deck: no card repeats until every card has been drawn once
     (per page visit; nothing is stored).
   - Testing: add ?nfr-card=2 to the page URL to make the first draw show the 3rd card (0-based index).
   - Stretches the background to the theme's content area (--nfr-bleed-w / --nfr-bleed-ml).
   - No dependencies, no cookies, no storage, no network requests. */
(function () {
  'use strict';

  function shuffled(count) {
    var a = [];
    for (var i = 0; i < count; i++) a.push(i);
    for (var j = a.length - 1; j > 0; j--) {
      var k = Math.floor(Math.random() * (j + 1));
      var t = a[j]; a[j] = a[k]; a[k] = t;
    }
    return a;
  }

  function forcedIndex(count) {
    var match = /[?&]nfr-card=(\d+)/.exec(window.location.search);
    if (!match) return -1;
    var i = parseInt(match[1], 10);
    return i >= 0 && i < count ? i : -1;
  }

  function preload(article) {
    var img = article && article.querySelector('img');
    if (img) { var pre = new Image(); pre.src = img.currentSrc || img.src; }
  }

  function init(root) {
    if (root.getAttribute('data-nfr-ready')) return;
    root.setAttribute('data-nfr-ready', '1');

    var card = root.querySelector('.nfr-kd__card');
    var drawnImg = root.querySelector('.nfr-kd__drawn');
    var drawBtn = root.querySelector('.nfr-kd__draw');
    var againBtn = root.querySelector('.nfr-kd__again');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.nfr-kd__meaning'));
    if (!card || !drawnImg || !drawBtn || !cards.length) return;

    var labelDraw = root.getAttribute('data-label-draw') || 'Turn the card';
    var labelDrawn = root.getAttribute('data-label-drawn') || 'Your card: ';
    var bag = [];
    var current = -1;
    var busy = false;
    var forced = forcedIndex(cards.length);

    function refill() {
      bag = shuffled(cards.length);
      // never start a new round with the card that is on the table now
      if (bag.length > 1 && bag[bag.length - 1] === current) bag.unshift(bag.pop());
    }
    function next() {
      if (forced >= 0) {
        var f = forced;
        forced = -1;
        bag = shuffled(cards.length).filter(function (x) { return x !== f; }); // rest of the first round
        return f;
      }
      if (!bag.length) refill();
      return bag.pop();
    }
    function peek() {
      if (!bag.length) refill();
      return bag[bag.length - 1];
    }

    function reveal(i) {
      var chosen = cards[i];
      var img = chosen.querySelector('img');
      drawnImg.src = img ? (img.currentSrc || img.src) : '';
      drawnImg.alt = img ? img.alt : '';
      card.classList.add('is-flipped');
      var title = chosen.querySelector('h3');
      card.setAttribute('aria-label', labelDrawn + (title ? title.textContent : ''));
      current = i;
      window.setTimeout(function () {
        chosen.classList.add('is-active');
        root.classList.add('has-drawn');
        busy = false;
        preload(cards[peek()]); // get the next card's image ready
      }, 600);
    }

    function draw() {
      if (busy || card.classList.contains('is-flipped')) return;
      busy = true;
      reveal(next());
    }

    function drawAgain() {
      if (busy) return;
      busy = true;
      for (var i = 0; i < cards.length; i++) cards[i].classList.remove('is-active');
      root.classList.remove('has-drawn');
      card.classList.remove('is-flipped');
      card.setAttribute('aria-label', labelDraw);
      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(function () { reveal(next()); }, 700);
    }

    root.classList.add('is-ready');
    preload(cards[forced >= 0 ? forced : peek()]);

    card.addEventListener('click', draw);
    drawBtn.addEventListener('click', draw);
    if (againBtn) againBtn.addEventListener('click', drawAgain);
  }

  // Full-bleed background: stretch the section to the nearest ancestor that clips its content
  // (overflow hidden/clip, e.g. Dyad's #content = right half of the screen) or to the window.
  function bleedArea(el) {
    for (var a = el.parentElement; a && a !== document.body; a = a.parentElement) {
      var ox = window.getComputedStyle(a).overflowX;
      if (ox === 'hidden' || ox === 'clip') return a;
    }
    return document.documentElement;
  }
  function setWidth() {
    var roots = document.querySelectorAll('.nfr-kd');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i], parent = root.parentElement;
      if (!parent) continue;
      // data-nfr-bleed="off" = stay inside the text column; data-nfr-bleed="#content" = stretch to that element
      var mode = root.getAttribute('data-nfr-bleed');
      if (mode === 'off') {
        root.style.removeProperty('--nfr-bleed-w');
        root.style.removeProperty('--nfr-bleed-ml');
        continue;
      }
      var area = null;
      if (mode) { try { area = document.querySelector(mode); } catch (e) { area = null; } }
      if (!area) area = bleedArea(root);
      var areaLeft = area === document.documentElement ? 0 : area.getBoundingClientRect().left + area.clientLeft;
      var ps = window.getComputedStyle(parent);
      var parentLeft = parent.getBoundingClientRect().left + parent.clientLeft + parseFloat(ps.paddingLeft);
      root.style.setProperty('--nfr-bleed-w', area.clientWidth + 'px');
      root.style.setProperty('--nfr-bleed-ml', (areaLeft - parentLeft) + 'px');
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('.nfr-kd');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
    setWidth();
    window.addEventListener('resize', setWidth);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
